/**
 * Simple Base64 encoding for basic obfuscation
 * Note: This is NOT secure encryption - it's just encoding
 * For production, use proper encryption like AES or RSA
 * @param data The data to encode (string or object)
 * @returns Base64 encoded string
 */
export function encodeBase64(data: any): string {
    try {
        // Convert data to string if it's an object
        const dataStr = typeof data === 'string' ? data : JSON.stringify(data)
        // Encode to Base64
        return btoa(unescape(encodeURIComponent(dataStr)))
    } catch (error) {
        throw new Error('Failed to encode data')
    }
}

/**
 * Decodes Base64 string back to original data
 * @param encodedStr Base64 encoded string
 * @returns Decoded string or object (if it was a JSON string)
 */
export function decodeBase64(encodedStr: string): any {
    try {
        // Decode from Base64
        const decodedStr = decodeURIComponent(escape(atob(encodedStr)))

        // Try to parse as JSON, return as is if not valid JSON
        try {
            return JSON.parse(decodedStr)
        } catch {
            return decodedStr
        }
    } catch (error) {
        throw new Error('Failed to decode data')
    }
}
